import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, HashRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './ScrollToTop';
import Layout from './pages/Layout';
import Home from './pages/Home';
import NoPage from './pages/NoPage';

// Detail pages are code-split: the home page no longer ships all 24 of them.
const Experiences = () => import('./pages/Experiences');
const ProjectPages = () => import('./pages/Projects');

const exp = (name) => lazy(() => Experiences().then((m) => ({ default: m[name] })));
const prj = (name) => lazy(() => ProjectPages().then((m) => ({ default: m[name] })));

const Roots2stem   = exp('Roots2stem');
const FRC4627      = exp('FRC4627');
const FRC5078      = exp('FRC5078');
const Toyota       = exp('Toyota');
const Toyota2023   = exp('Toyota2023');
const UofTHacks    = exp('UofTHacks');
const UofTHacksXI  = exp('UofTHacksXI');
const Hackthe6ix   = exp('Hackthe6ix');
const MakeUofT     = exp('MakeUofT');
const GoodlabsRobot = exp('GoodlabsRobot');
const GoodlabsRL   = exp('GoodlabsRL');
const HackMIT      = exp('HackMIT');
const CalHacks     = exp('CalHacks');
const Envgo        = exp('Envgo');
const Watonomous   = exp('Watonomous');
const DeepTrekker  = exp('DeepTrekker');

const Project1a   = prj('Project1a');
const PiLaptop    = prj('PiLaptop');
const Marketalarm = prj('Marketalarm');
const Gokart      = prj('Gokart');
const Plant       = prj('Plant');
const Openmv      = prj('Openmv');
const RCplanes    = prj('RCplanes');
const Sanitizer   = prj('Sanitizer');

const Loading = () => (
  <div className="mc-shell" style={{ padding: '6rem 0', textAlign: 'center' }}>
    <p className="mc-eyebrow">Loading…</p>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <ScrollToTop />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />

            <Route path="deeptrekker" element={<DeepTrekker />} />
            <Route path="watonomous" element={<Watonomous />} />
            <Route path="envgo" element={<Envgo />} />
            <Route path="goodlabsrobotics" element={<GoodlabsRobot />} />
            <Route path="goodlabsrl" element={<GoodlabsRL />} />
            <Route path="roots2stem" element={<Roots2stem />} />
            <Route path="frc4627" element={<FRC4627 />} />
            <Route path="frc5078" element={<FRC5078 />} />

            <Route path="calhacks" element={<CalHacks />} />
            <Route path="hackmit" element={<HackMIT />} />
            <Route path="makeuoft" element={<MakeUofT />} />
            <Route path="uofthacksXI" element={<UofTHacksXI />} />
            <Route path="hackthe6ix" element={<Hackthe6ix />} />
            <Route path="uofthacksX" element={<UofTHacks />} />
            <Route path="toyotainnovation" element={<Toyota />} />
            <Route path="toyotainnovation2023" element={<Toyota2023 />} />

            <Route path="1afinalproject" element={<Project1a />} />
            <Route path="RPilaptop" element={<PiLaptop />} />
            <Route path="marketalarm" element={<Marketalarm />} />
            <Route path="gokart" element={<Gokart />} />
            <Route path="plant" element={<Plant />} />
            <Route path="openmv" element={<Openmv />} />
            <Route path="rcplanes" element={<RCplanes />} />
            <Route path="sanitizer" element={<Sanitizer />} />

            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </Suspense>
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
